import { BasePattern } from "@patternslib/patternslib/src/core/basepattern";
import registry from "@patternslib/patternslib/src/core/registry";

class Pattern extends BasePattern {
    static name = "sfd-toolbar";
    static trigger = ".pat-toolbar";
}

registry.register(Pattern);
export default Pattern;
export { Pattern };
